import type { TransactionType } from '../types/wallet';

const TRANSACTION_TYPE_LABELS: Record<TransactionType, string> = {
  PaymentGatewayCharge: 'شحن عبر بوابة الدفع',
  WalletCodeCharge: 'شحن بكود المحفظة',
  CoinsUsage: 'شراء من المحفظة',
  DirectCoursePurchase: 'شراء كورس',
};

export function getTransactionTypeLabel(type: string): string {
  return TRANSACTION_TYPE_LABELS[type as TransactionType] ?? type;
}

export function formatWalletDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function formatCoins(amount: number): string {
  return Math.abs(amount).toLocaleString('ar-EG');
}

export function formatCoinsDelta(amount: number): string {
  const sign = amount > 0 ? '+' : amount < 0 ? '−' : '';
  return `${sign}${formatCoins(amount)}`;
}

export function formatTransactionDescription(
  description: string | undefined,
  type?: string
): string {
  if (!description?.trim()) {
    return type ? getTransactionTypeLabel(type) : '';
  }

  const d = description.trim();

  const purchasedCourse = /^Purchased course:\s*(.+)$/i.exec(d);
  if (purchasedCourse) {
    return `شراء كورس: ${purchasedCourse[1].trim()}`;
  }

  const purchasedUnit = /^Purchased unit:\s*(.+)$/i.exec(d);
  if (purchasedUnit) {
    return `شراء حصة: ${purchasedUnit[1].trim()}`;
  }

  const walletRecharge = /^Recharged\s+(\d+)\s+coins?\s+using\s+wallet\s+code:\s*(\S+)$/i.exec(d);
  if (walletRecharge) {
    const coins = Number(walletRecharge[1]);
    return `شحن ${formatCoins(coins)} عملة بكود المحفظة: ${walletRecharge[2]}`;
  }

  const walletCharge = /^Wallet Charge\s+(\d+)\s+Coins?$/i.exec(d);
  if (walletCharge) {
    return `شحن ${formatCoins(Number(walletCharge[1]))} عملة للمحفظة`;
  }

  return d;
}

export const WALLET_CODE_PATTERN = /^\d{7}$/;

export function isValidWalletCode(code: string): boolean {
  return WALLET_CODE_PATTERN.test(code.trim());
}
